export enum jobSheetReportsActions {

  //get jobsheet reports
  GET_JOBSHEET_REPORTS_LOADING = "@@jobsheetReports/GET_JOBSHEET_REPORTS_LOADING",
  GET_JOBSHEET_REPORTS_SUCCESS = "@@jobsheetReports/GET_JOBSHEET_REPORTS_SUCCESS",
  GET_JOBSHEET_REPORTS_ERROR = "@@jobsheetReports/GET_JOBSHEET_REPORTS_ERROR",
}